import { Dispatch } from "redux";
import { ServerSettingsActionCreators } from "../../store/action-creators/serverSettingsActions";
import { SettingsApi } from "../agent";
import { SettingsSuccessResponse } from "../api/settings";

const processValue = (value: string | boolean | number) => {
  if (value === "true") return true;
  if (value === "false") return false;
  return value;
};

type Setting = {
  [K in SettingsSuccessResponse["data"][number]["code"]]: ReturnType<
    typeof processValue
  >;
};

export const fetchServerSettingsThunk = () => async (dispatch: Dispatch) => {
  const settingsRes = await SettingsApi.getSettings();

  if (!settingsRes.result) {
    console.error("Ошибка при получении серверных настроек");
    return;
  }

  const settings = settingsRes.data.reduce((acc, setting) => {
    acc[setting.code] = processValue(setting.value);
    return acc;
  }, {} as Setting);

  dispatch(ServerSettingsActionCreators.set(settings));
};
